export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', seq: 'cat-shoes' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', seq: 'cat-hoodies' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html', seq: 'cat-tshirts' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html', seq: 'cat-jackets' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html', seq: 'cat-pants' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html', seq: 'cat-headwear' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html', seq: 'cat-sets' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html', seq: 'cat-underwear' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html', seq: 'cat-jersey' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html', seq: 'cat-accessories' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html', seq: 'cat-bags' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html', seq: 'cat-belts' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html', seq: 'cat-perfumes' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html', seq: 'cat-other' },
];

export const categoryThumbnails: Record<string, string> = {
  'cat-shoes': 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20colorful%20athletic%20sneakers%20on%20light%20wooden%20surface%2C%20vibrant%20orange%20and%20white%20colorway%2C%20clean%20product%20photography%2C%20bright%20natural%20lighting%2C%20simple%20composition&width=80&height=80&seq=nav-thumb-shoes&orientation=squarish',
  'cat-hoodies': 'https://readdy.ai/api/search-image?query=Single%20casual%20gray%20hoodie%20sweater%20neatly%20folded%20on%20light%20surface%2C%20minimal%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20composition&width=80&height=80&seq=nav-thumb-hoodies&orientation=squarish',
  'cat-tshirts': 'https://readdy.ai/api/search-image?query=Single%20classic%20black%20cotton%20t-shirt%20flat%20lay%20on%20white%20surface%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20studio%20lighting&width=80&height=80&seq=nav-thumb-tshirts&orientation=squarish',
  'cat-jackets': 'https://readdy.ai/api/search-image?query=Single%20stylish%20denim%20jacket%20on%20wooden%20hanger%20against%20light%20wall%2C%20product%20photography%2C%20natural%20daylight%2C%20minimalist%20composition&width=80&height=80&seq=nav-thumb-jackets&orientation=squarish',
  'cat-pants': 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20casual%20beige%20chino%20pants%20folded%20on%20light%20surface%2C%20clean%20product%20photography%2C%20bright%20natural%20light%2C%20simple%20style&width=80&height=80&seq=nav-thumb-pants&orientation=squarish',
  'cat-headwear': 'https://readdy.ai/api/search-image?query=Single%20trendy%20snapback%20cap%20in%20olive%20green%20on%20light%20surface%2C%20clean%20product%20photography%2C%20soft%20studio%20lighting%2C%20minimalist%20look&width=80&height=80&seq=nav-thumb-headwear&orientation=squarish',
  'cat-sets': 'https://readdy.ai/api/search-image?query=Matching%20two%20piece%20clothing%20set%20in%20soft%20pastel%20pink%20folded%20on%20light%20surface%2C%20clean%20product%20photography%2C%20gentle%20natural%20light&width=80&height=80&seq=nav-thumb-sets&orientation=squarish',
  'cat-underwear': 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20set%20neatly%20arranged%20on%20light%20surface%2C%20minimalist%20product%20photography%2C%20clean%20composition%2C%20soft%20studio%20light&width=80&height=80&seq=nav-thumb-underwear&orientation=squarish',
  'cat-jersey': 'https://readdy.ai/api/search-image?query=Sports%20team%20jersey%20in%20bold%20red%20and%20white%20stripes%20on%20light%20surface%2C%20clean%20product%20photography%2C%20bright%20natural%20lighting&width=80&height=80&seq=nav-thumb-jersey&orientation=squarish',
  'cat-accessories': 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20wristwatch%20with%20leather%20strap%20on%20light%20surface%2C%20elegant%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20aesthetic&width=80&height=80&seq=nav-thumb-accessories&orientation=squarish',
  'cat-bags': 'https://readdy.ai/api/search-image?query=Single%20canvas%20tote%20bag%20in%20natural%20beige%20color%20on%20light%20wooden%20surface%2C%20minimalist%20product%20photography%2C%20natural%20daylight&width=80&height=80&seq=nav-thumb-bags&orientation=squarish',
  'cat-belts': 'https://readdy.ai/api/search-image?query=Single%20genuine%20leather%20belt%20coiled%20on%20light%20surface%2C%20clean%20product%20photography%2C%20warm%20natural%20lighting%2C%20minimalist%20style&width=80&height=80&seq=nav-thumb-belts&orientation=squarish',
  'cat-perfumes': 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20golden%20liquid%20on%20light%20marble%20surface%2C%20luxury%20product%20photography%2C%20soft%20studio%20lighting%2C%20refined%20aesthetic&width=80&height=80&seq=nav-thumb-perfumes&orientation=squarish',
  'cat-other': 'https://readdy.ai/api/search-image?query=Assorted%20small%20fashion%20accessories%20including%20sunglasses%20and%20jewelry%20on%20light%20surface%2C%20clean%20product%20photography%2C%20bright%20natural%20light&width=80&height=80&seq=nav-thumb-other&orientation=squarish',
};

export const featureGuides = [
  {
    title: 'What Is Mulebuy Spreadsheet',
    subtitle: 'Read Full Guide',
    slug: '/mulebuy-spreadsheet-complete-guide',
    seq: 'feature-what-is',
  },
  {
    title: 'How to Use Mulebuy Spreadsheet Safely',
    subtitle: 'Read Safety Guide',
    slug: '/mulebuy-spreadsheet-safety-tips',
    seq: 'feature-how-to',
  },
  {
    title: 'Mulebuy Spreadsheet vs Agent Shopping 2026',
    subtitle: 'Read Comparison',
    slug: '/mulebuy-spreadsheet-vs-traditional-shopping',
    seq: 'feature-vs',
  },
];

export const seoArticleCards = [
  {
    title: 'Beginner Tutorial',
    subtitle: 'Your first steps to smarter shopping with mulebuy spreadsheet',
    slug: '/mulebuy-spreadsheet-beginner-tutorial',
    seq: 'home-article-b1',
  },
  {
    title: 'Pricing Guide',
    subtitle: 'Understanding all costs and fees in mulebuy spreadsheet',
    slug: '/mulebuy-spreadsheet-pricing-guide',
    seq: 'home-article-b2',
  },
  {
    title: 'Safety Tips',
    subtitle: 'How to shop securely using mulebuy spreadsheet platforms',
    slug: '/mulebuy-spreadsheet-safety-tips',
    seq: 'home-article-b3',
  },
  {
    title: 'vs Traditional Shopping',
    subtitle: 'Which method saves more time and money with mulebuy spreadsheet',
    slug: '/mulebuy-spreadsheet-vs-traditional-shopping',
    seq: 'home-article-b4',
  },
  {
    title: 'Best Practices 2026',
    subtitle: 'Expert tips for power users of mulebuy spreadsheet',
    slug: '/mulebuy-spreadsheet-best-practices-2026',
    seq: 'home-article-b5',
  },
  {
    title: 'Tools Comparison',
    subtitle: 'Finding the right mulebuy spreadsheet platform for your needs',
    slug: '/mulebuy-spreadsheet-tools-comparison',
    seq: 'home-article-b6',
  },
  {
    title: 'Bulk Ordering Guide',
    subtitle: 'How to save big on large purchases with mulebuy spreadsheet',
    slug: '/mulebuy-spreadsheet-bulk-ordering',
    seq: 'home-article-b7',
  },
  {
    title: 'FAQ & Troubleshooting',
    subtitle: 'Common questions and solutions for mulebuy spreadsheet users',
    slug: '/mulebuy-spreadsheet-faq-troubleshooting',
    seq: 'home-article-b8',
  },
  {
    title: 'Mobile Shopping Guide',
    subtitle: 'Using mulebuy spreadsheet on your smartphone effectively',
    slug: '/mulebuy-spreadsheet-mobile-guide',
    seq: 'home-article-b9',
  },
];

export const trustFeatures = [
  { icon: 'ri-shield-check-line', label: 'Safe Checkout' },
  { icon: 'ri-eye-line', label: 'Transparent Pricing' },
  { icon: 'ri-flashlight-line', label: 'Fast Comparison' },
  { icon: 'ri-book-open-line', label: 'Verified Guides' },
  { icon: 'ri-flow-chart', label: 'User Workflows' },
];

export const siteConfig = {
  siteName: 'Mulebuy Spreadsheet Hub',
  tagline: 'The Complete Mulebuy Spreadsheet Resource Hub',
  domain: 'https://mulebuyspreadsheets.buzz',
  mainSite: 'https://kaspreadsheet.com',
  mainSiteName: 'KA Spreadsheet',
};